import { connect } from 'react-redux';
import { onSubmit, resetMeta, resetPage } from '../../actions/SettingPage';
import SettingPage from './SettingPage';

const mapsStateToProps = state => ({
	settingPageProps: state.settingPageReducer
});

const mapsDispatchToProps = dispatch => ({
	onSubmit(options) {
		dispatch(onSubmit(options));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(SettingPage);
